import { useCallback, useEffect } from 'react';
import { SelectAllHotkeys } from 'src/components/common/MultiSelect/Toggle/contants';
import { MultiSelectionToggle } from 'src/components/common/MultiSelect/Toggle/MultiSelectionToggle';
import { useCommandMenuContext } from 'src/contexts/CommandMenuContext/CommandMenuContext';
import {
  MultiSelectScope,
  useMultiSelectionContext,
} from 'src/contexts/MultiSelectionContext';
import { PosHotkeys } from 'src/core/POS/PosHotkeys';
import { useEnableSelectionByDefault } from 'src/hooks/useEnableSelectionByDefault';
import { CommandOptionType } from 'src/WebApiController';

type MultiSelectionToggleGlobalProps = {
  variant?: 'button' | 'checkbox';
};

export const MultiSelectionToggleGlobal = (
  props: MultiSelectionToggleGlobalProps
) => {
  const enableSelectionByDefault = useEnableSelectionByDefault();

  if (enableSelectionByDefault) {
    return null;
  }

  return <MultiSelectionToggleGlobalContent {...props} />;
};

const MultiSelectionToggleGlobalContent = ({
  variant,
}: MultiSelectionToggleGlobalProps) => {
  const { selectionMode, setSelectionMode } = useMultiSelectionContext();
  const { registerCommand, unregisterCommand } = useCommandMenuContext();

  const onMultiSelectListingClick = useCallback(() => {
    setSelectionMode(
      selectionMode?.mode !== MultiSelectScope.AllGroups
        ? { mode: MultiSelectScope.AllGroups }
        : undefined
    );
  }, [selectionMode, setSelectionMode]);

  const isChecked = selectionMode?.mode === MultiSelectScope.AllGroups;

  useEffect(() => {
    registerCommand({
      command: {
        id: CommandOptionType.ToggleSelectionMode,
        onSelect: () =>
          setSelectionMode(
            selectionMode?.mode !== MultiSelectScope.AllGroups
              ? { mode: MultiSelectScope.AllGroups }
              : undefined
          ),
      },
    });

    return () => {
      unregisterCommand({ commandId: CommandOptionType.ToggleSelectionMode });
    };
  }, [
    unregisterCommand,
    registerCommand,
    selectionMode?.mode,
    setSelectionMode,
  ]);

  return (
    <PosHotkeys
      keyNames={SelectAllHotkeys}
      onHotkeyActivated={onMultiSelectListingClick}
    >
      <MultiSelectionToggle
        onChange={onMultiSelectListingClick}
        isToggled={isChecked}
        variant={variant}
      />
    </PosHotkeys>
  );
};
